import { render } from "./RiskButton.vue?vue&type=template&id=b24388c2&scoped=true"
import script from "./RiskButton.vue?vue&type=script&lang=js"
export * from "./RiskButton.vue?vue&type=script&lang=js"

import "./RiskButton.vue?vue&type=style&index=0&id=b24388c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24388c2"]])

export default __exports__